import { render, staticRenderFns } from "./LoginPlanificaciones.vue?vue&type=template&id=970a17ae&scoped=true&lang=html"
import script from "./LoginPlanificaciones.vue?vue&type=script&lang=js"
export * from "./LoginPlanificaciones.vue?vue&type=script&lang=js"
import style0 from "./LoginPlanificaciones.vue?vue&type=style&index=0&id=970a17ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970a17ae",
  null
  
)

export default component.exports